import React, { useEffect, useState, useMemo } from "react";
import CommonDataTable from "../../components/CommonDataTable";
import {
    IconButton,
    Menu,
    MenuItem,
    Checkbox
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { fetchCycleCount } from "../../services/cyclecount/cyclecount";

/* ================= HEADER ONLY ROW MAPPER ================= */
const mapCycleCountHeaderRows = (apiData = []) =>
    apiData.map((item) => {
        const h = item.CycleCountHeader || {};
        return {
            id: item._id,
            __raw: item,

            cyclecountkey: h.cyclecountkey ?? "",
            Warehouse: h.Warehouse ?? "",
            CreatedBy: h.CreatedBy ?? "",
            owner: h.owner ?? "",
            status: h.status ?? "",
            item: h.item ?? "",
            location: h.location ?? "",
            adjustment_reason: h["adjustment reason"] ?? "",
            reference_num: h["reference num"] ?? "",
            initiating_document_id: h["initiating document id"] ?? ""
        };
    });

/* ================= BASE COLUMNS ================= */
const baseColumns = [
    { field: "cyclecountkey", headerName: "Cycle Count Key", width: 160 },
    { field: "Warehouse", headerName: "Warehouse", width: 120 },
    { field: "CreatedBy", headerName: "Created By", width: 150 },
    { field: "owner", headerName: "Owner", width: 120 },
    { field: "status", headerName: "Status", width: 120 },
    { field: "item", headerName: "Item", width: 120 },
    { field: "location", headerName: "Location", width: 120 },
    { field: "adjustment_reason", headerName: "Adjustment Reason", width: 160 },
    { field: "reference_num", headerName: "Reference No", width: 160 },
    { field: "initiating_document_id", headerName: "Initiating Document ID", width: 200 },
    
];

export default function CycleCountImportList({ onView }) {
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    // ✅ checkbox selection state
    const [selectedIds, setSelectedIds] = useState([]);

    // action menu
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);

    useEffect(() => {
        loadData(page, pageSize);
    }, [page, pageSize]);

    const loadData = async (pageNo, size) => {
        const res = await fetchCycleCount(pageNo, size);
        const list = res?.data || [];
        const totalCount = res?.totalCount || 0;

        setRows(mapCycleCountHeaderRows(list));
        setTotal(totalCount);
        setSelectedIds([]); // reset selection on reload
    };

    const handleDataRefresh = async (payload = {}) => {
        const p = payload.page !== undefined ? payload.page : page;
        const ps = payload.pageSize !== undefined ? payload.pageSize : pageSize;
        await loadData(p, ps);
    };

    /* ================= CHECKBOX HELPERS ================= */
    const toggleRow = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((x) => x !== id)
                : [...prev, id]
        );
    };

    const allSelected = rows.length > 0 && selectedIds.length === rows.length;
    const someSelected = selectedIds.length > 0 && !allSelected;

    /* ================= ACTION COLUMN ================= */
    const actionColumn = useMemo(() => ({
        field: "__actions",
        headerName: "",
        width: 80,
        sortable: false,

        // 🔥 HEADER CHECKBOX (select all)
        renderHeader: () => (
            <Checkbox
                size="small"
                indeterminate={someSelected}
                checked={allSelected}
                onChange={(e) => {
                    if (e.target.checked) {
                        setSelectedIds(rows.map((r) => r.id));
                    } else {
                        setSelectedIds([]);
                    }
                }}
            />
        ),

        // 🔥 ROW CHECKBOX + MENU
        renderCell: (params) => (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              

                <IconButton
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        setMenuAnchorEl(e.currentTarget);
                        setMenuRow(params.row);
                    }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </div>
        )
    }), [rows, selectedIds, allSelected, someSelected]);

    return (
        <>
            <CommonDataTable
                id="cycle-count-list"
                allPossibleColumns={[actionColumn, ...baseColumns]}
                initialVisible={["__actions", ...baseColumns.map(c => c.field)]}
                initialRows={rows}
                rowCount={total}
                page={page}
                pageSize={pageSize}
                onPageChange={(newPage) => setPage(newPage)}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
                height={500}

                showCreateButton={false}
                enableImportButton={true}
                enableExportButton={false}

                checkboxSelection={true} // ❌ default datagrid checkbox off
                readOnly                  // view-only mode
                onDataRefresh={handleDataRefresh}
                forInventory
            />

            {/* ===== ACTION MENU ===== */}
            <Menu
                open={!!menuAnchorEl}
                anchorEl={menuAnchorEl}
                onClose={() => setMenuAnchorEl(null)}
            >
                <MenuItem
                    onClick={() => {
                        onView(menuRow.id);
                        setMenuAnchorEl(null);
                    }}
                >
                    <i className="bi bi-eye me-2" /> View
                </MenuItem>
            </Menu>
        </>
    );
}
